var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loadingScreen', {'show': _vm.show}]},[_c('img',{staticClass:"logo",attrs:{"src":"/images/logoSmall.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }